import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    props: {
        data: {
            type: Array,
            default: () => []
        },
        dots: {
            type: Boolean,
            default: false
        }
    }
});
